"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Update2dGroup = void 0;
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * {@inheritDoc IUpdate2dGroup}
 */
class Update2dGroup extends core_1.AEntityGroup {
    constructor(updateArgProvider, categories = new core_1.CategoryStore()) {
        super();
        this.updateArgProvider = updateArgProvider;
        this.categories = categories;
        this.entitiesInGroup = new Set();
        this.graphicsComponents = new core_1.EntityComponentStore();
    }
    onEntityAdded(entity, options) {
        this.graphicsComponents.setComponent(entity, options.graphicsComponent);
        this.entitiesInGroup.add(entity);
    }
    onEntityRemoved(entity) {
        this.graphicsComponents.deleteComponent(entity);
        this.entitiesInGroup.delete(entity);
        const categories = this.categories.toArray();
        for (let i = 0, iEnd = categories.length; i < iEnd; ++i) {
            categories[i].removeEntity(entity);
        }
    }
}
exports.Update2dGroup = Update2dGroup;
//# sourceMappingURL=update-2d-group.js.map